import { Component, Input, OnInit } from '@angular/core';
import { CSSMonitorService } from '../../services/css-monitor.service';
import { Subscription } from 'rxjs';

/**
 * This class represents the information modal component
 */
@Component({
    selector: 'info-modal',
    templateUrl: 'info-modal.component.html',
    standalone: false
})

export class InfoModalComponent {
	private subscription: Subscription = null;
	public cssDisabled:boolean = false;
	
	@Input('translate-src')
	translateSrc: string;

	@Input()
	id: string;

	@Input()
	title: string;
     
    @Input()
    buttonText : string;

	private screenShotInfoShown: boolean;

	constructor(
		private cssMonitorService: CSSMonitorService
	) { }

	ngOnInit(): void {
		this.screenShotInfoShown = false;
		this.cssMonitorService.start();
        this.subscription = this.cssMonitorService.styleChangeEvent.subscribe(
			(gotCss:string) => {
				if (gotCss === this.cssMonitorService.CSS_DISABLED) {
					this.handleCSSDisabled();
				} else {
					this.handleCSSEnabled();
				}
			}
		);
	}

	ngOnDestroy() {
        this.subscription.unsubscribe();
    }

	protected handleCSSDisabled() {
		this.cssDisabled = true;
	}

	protected handleCSSEnabled() {
		this.cssDisabled = false;
	}
}
